"use client";
import { PanelTitle } from "./Layout/PanelTitle";
import { useGetHostingPackagesQuery } from "@/store";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { PriceHostingContent } from "./PriceHostingContent";

export const WHPanelContent = ({ page }) => {
  
  const location = usePathname();
  const t = useTranslations();
  const { data } = useGetHostingPackagesQuery();
  let firstPackageCost = data?.body?.hosting_packages[0]?.cost;
  const offers = ["Fast Speed", "24/7 Support", "99,90% Uptime Guarantee"];
  const content = {
    price: firstPackageCost,
    btnText: t("viewPlans"),
    redirect: location + "/purchase",
  };

  return (
    <div className={"flex flex-col justify-center items-center max-w-[628px]"}>
      <PanelTitle sectionName={page} />
      <div className="flex justify-center mt-[25px] items-center gap-[38px]">
        {offers.map((value, index) => {
          <div
            key={value + index}
            className="flex justify-center items-center gap-[16px]"
          >
            <Image
              src="/icons/circle_okay.svg"
              width={24}
              height={24}
              alt="icon"
            />
            <span>{value}</span>
          </div>;
        })}
      </div>
      {content?.price && <PriceHostingContent {...{ content }} />}
    </div>
  );
};
